export default __webpack_public_path__ + "static/media/bi.f60b0359.png";